export * from './sinister-type.component';
